module.exports = __webpack_public_path__ + "static/media/logo DIF-sf.5762b2fe.png";